const value = Object.freeze({
  Information: 0,
  History: 1,
  Binnacle: 2,
  Custodian:3,
});
export default value;
